import React from 'react';

import mp from '../assests/mapif.webp';

const ContactSection = () => {
  return (
    <div style={{paddingBottom:"40px"}} className="px-6">
        <h2 style={{fontWeight:"400"}} className="text-4xl mx-auto max-w-6xl mb-8">Contact Us Now</h2>
      <div className="max-w-6xl mx-auto sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        {/* Google Maps */}
        <div>
          {/* <div className="rounded-2xl overflow-hidden">
            <iframe title="Google Maps Location" src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d995.1545420612915!2d75.9040836154409!3d17.678506889203796!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e1!3m2!1sen!2sin!4v1734115150366!5m2!1sen!2sin"
                width="100%"
                height="400"
                style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div> */}
          <div className="relative rounded-2xl overflow-hidden">
       <img style={{width:'100%', height:'350px',border:'1px solid gray',borderRadius:'20px'}} src={mp} alt="Shop Location Map" />
        <button style={{zIndex:'10'}} className='absolute flex items-center justify-center gap-2 bottom-[10px] left-[10px] bg-gray-800 px-6 py-2 text-white rounded-full  self-center'><svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.86864 15.8842L14.0911 27.1342C14.5774 27.6217 15.3724 27.6229 15.8586 27.1367L27.1349 15.8867C27.2513 15.7706 27.3437 15.6326 27.4067 15.4808C27.4697 15.3289 27.5021 15.1661 27.5021 15.0017C27.5021 14.8373 27.4697 14.6745 27.4067 14.5226C27.3437 14.3707 27.2513 14.2328 27.1349 14.1167L15.8586 2.86669C15.6239 2.63268 15.3058 2.50149 14.9744 2.50195C14.6429 2.50242 14.3252 2.63452 14.0911 2.86919L2.86864 14.1192C2.63507 14.3535 2.50391 14.6708 2.50391 15.0017C2.50391 15.3325 2.63507 15.6499 2.86864 15.8842ZM11.2524 12.5017H17.5024V10.0017L21.2524 13.7517L17.5024 17.5017V15.0017H13.7524V20.0017H11.2524V12.5017Z" fill="white"/>
</svg>
<a href="https://maps.app.goo.gl/bTmcWWwC493arKAh7">Get Directions</a></button>
</div>

        </div>

        {/* Contact Information */}
        <div>
          <div className="space-y-6">
            <div className="flex items-center">
              <div className="w-10 h-10 bg-gray-300 rounded-full flex items-center justify-center mr-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </div>
              <a href="tel:+9130703656" className="text-gray-800 hover:text-gray-900 font-medium">
                +91 9130703656
              </a>
            </div>
            <div className="flex items-center">
              <div className="w-10 h-10 bg-gray-300 rounded-full flex items-center justify-center mr-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <a href="mailto:chauhansandip015@gmail.com?subject=Important!&body=Hi." className="text-gray-800 hover:text-gray-900 font-medium">
              chauhansandip015@gmail.com
              </a>
            </div>
            <div className="flex items-center">
              <div className="w-10 h-10 bg-gray-300 rounded-full flex items-center justify-center mr-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                </svg>
              </div>
              <a href="https://wa.me/1234567890" className="text-gray-800 hover:text-gray-900 font-medium">
              +91 9130703656
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;